import { generateRequest } from './index';

export const Action = {
  Home: {
    FetchHomeScreenCardsPending: 'FetchHomeScreenCards_PENDING',
    FetchHomeScreenCardsCompleted: 'FetchHomeScreenCards_FULFILLED',
    FetchHomeScreenCardsFailed: 'FetchHomeScreenCards_FAILED',
  },
};

export const fetchHomeScreenCards = () => generateRequest({
  endpoint: '/assets-v2/api/home/cards',
  types: [
    Action.Home.FetchHomeScreenCardsPending,
    Action.Home.FetchHomeScreenCardsCompleted,
    Action.Home.FetchHomeScreenCardsFailed,
  ],
});
